module.exports = __webpack_public_path__ + "img/logotipo.0590f5ed.png";